import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '@/components/Login.vue'

import * as firebase from "firebase/app";
import 'firebase/auth'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			autentificado: true
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login
	},
	{
		path: '*',
		redirect: '/login'
	},/*
	{
		path: '/',
		redirect: '/login'
	}*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function getCurrentUser() {
	return new Promise((resolve, reject) => {
		const unsubscribe = firebase.auth().onAuthStateChanged( 
			user => {
				unsubscribe();
				resolve(user);
			},
			() => {
				reject();
			}
		);
	});
};

router.beforeEach(async (to, from, next) => {
	let autorizacion =  to.matched.some(record => record.meta.autentificado);
	if (autorizacion && !(await getCurrentUser())) {
		next({ name: 'Login'})
	} else if (!autorizacion && await getCurrentUser()) {
		next({ name: 'Home'})
	} else {
		next();
	}
});

export default router
